var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useCallback, useState } from 'react';
export const useForm = (onSubmit) => {
    const [values, setValues] = useState({});
    const handleSubmit = useCallback((event) => {
        if (event)
            event.preventDefault();
        onSubmit(values);
    }, [onSubmit, values]);
    const handleChange = useCallback((event) => {
        const { name, type } = event.target;
        const isCheckbox = type === 'checkbox';
        setValues(prev => {
            const next = Object.assign({}, prev);
            if (isCheckbox && 'checked' in event.target) {
                next[name] = event.target.checked;
            }
            else {
                const value = event.target.value;
                if (value === '' || value == null) {
                    const _a = next, _b = name, _ = _a[_b], rest = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
                    return rest;
                }
                next[name] = value;
            }
            return next;
        });
    }, []);
    const overrideValue = useCallback((name, value) => {
        setValues(prev => (Object.assign(Object.assign({}, prev), { [name]: value })));
    }, []);
    const overrideValues = useCallback((...entries) => {
        setValues(prev => {
            const next = Object.assign({}, prev);
            for (const { name, value } of entries) {
                next[name] = value;
            }
            return next;
        });
    }, []);
    return {
        values,
        handleChange,
        handleSubmit,
        overrideValue,
        overrideValues,
        setValues,
    };
};
